export default angular
  .module("ModifyBlockingCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyBlockingController", [
    "$scope",
    "scriptData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "System",
    function (
      $scope,
      scriptData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      System,
    ) {
      const changedFields = new Map();

      $scope.ok = function () {
        const blockingsValue = {};
        blockingsValue.BLOCKINGS = "";
        if (changedFields.get("blocking")) {
          $scope.countries.forEach((entry) => {
            if (entry.CHECKED == true) {
              blockingsValue.BLOCKINGS += `,${entry.ABBREVIATION}`;
            }
          });
          if (blockingsValue.BLOCKINGS.length > 0) {
            blockingsValue.BLOCKINGS += ",";
          } else {
            blockingsValue.BLOCKINGS = ",0,";
          }
          Scripts.updateBlockings(blockingsValue, scriptData.ID, () => {
            scriptData.BLOCKINGS = blockingsValue.BLOCKINGS;
          });
        }
        $modalInstance.close();
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      System.loadCountries((data) => {
        $scope.countries = data;
        for (let i = 0; $scope.countries.length > i; i++) {
          if (scriptData.BLOCKINGS) {
            if (
              scriptData.BLOCKINGS.indexOf($scope.countries[i].ABBREVIATION) >=
              0
            ) {
              $scope.countries[i].CHECKED = true;
            }
          }
        }
      });

      $scope.changedField = function (entity) {
        changedFields.set(entity, true);
      };
    },
  ]);
